import React from "react";

const ListingPaginationFooter = ({
  totalElements = 0,
  resultsLabel,
  page = 0,
  totalPages = 0,
  loading = false,
  onPrevious,
  onNext,
  previousLabel = "Previous",
  nextLabel = "Next",
  extra,
}) => {
  const safeTotalPages = Math.max(totalPages, 1);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-4 py-3 sm:px-5">
      <p className="text-xs text-slate-500">
        {totalElements.toLocaleString()} {resultsLabel}
      </p>
      <div className="flex items-center gap-2">
        {extra}
        <button
          type="button"
          disabled={page <= 0 || loading}
          onClick={onPrevious}
          className="h-9 rounded-xl border border-slate-200 bg-white px-4 text-sm font-medium text-slate-600 transition hover:bg-slate-50 disabled:opacity-50"
        >
          {previousLabel}
        </button>
        <span className="min-w-[72px] text-center text-sm text-slate-600">
          {page + 1} / {safeTotalPages}
        </span>
        <button
          type="button"
          disabled={page + 1 >= totalPages || loading}
          onClick={onNext}
          className="h-9 rounded-xl border border-slate-200 bg-white px-4 text-sm font-medium text-slate-600 transition hover:bg-slate-50 disabled:opacity-50"
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
};

export default ListingPaginationFooter;
